module.exports = __webpack_public_path__ + "assets/img/1_662_big.19357346.jpg";